import React, { useState, useCallback, useEffect } from "react";
import { FormattedMessage } from "react-intl";

import Modal from "../../../../../Modal";
import Form, { Title, Checkbox, Submit } from "../../../../../Form";

import { get, set } from "./store";
import messages from "./messages";

const IntervalInputHintModal = () => {
    const [isOpen, setOpen] = useState(false);
    const [isChecked, changeIsChecked] = useState(false);
    const handleChange = useCallback(() => {
        changeIsChecked(oldValue => !oldValue);
    }, []);

    useEffect(() => {
        if (!get()) {
            setOpen(true);
        }
    }, []);
    const handleClose = useCallback(() => {
        if (isChecked) {
            set();
        }
        setOpen(false);
    }, [isChecked]);

    if (!isOpen) return null;
    return (
        <Modal close={handleClose}>
            <Title>
                <FormattedMessage {...messages.title} />
            </Title>
            <Form>
                <p style={{ marginTop: 0 }}>
                    <FormattedMessage {...messages.description} />
                </p>
                <Checkbox
                    label={<FormattedMessage {...messages.noMore} />}
                    checked={isChecked}
                    onChange={handleChange}
                />
                <Submit onClick={handleClose}>
                    <FormattedMessage {...messages.close} />
                </Submit>
            </Form>
        </Modal>
    );
};

export default IntervalInputHintModal;
